import img1 from "../../assets/img1.webp";
import img2 from "../../assets/img2.webp";
import img3 from "../../assets/img3.webp";
import img4 from "../../assets/img4.webp";
import img5 from "../../assets/img5.webp";
import img6 from "../../assets/img6.jpeg";
import img7 from "../../assets/img7.webp";
import img8 from "../../assets/img8.webp";
import img9 from "../../assets/img9.webp";
import img10 from "../../assets/img10.webp";

const places = [
    {
        image: img1,
        region: "Europe",
        country: "Croatia",
        place: "Beach",
        price: 500,
        weather: "night"
    },
    {
        image: img2,
        region: "United Arab Emirates",
        country: "Dubai",
        place: "Modern",
        price: 1200,
        weather: "morning"
    },
    {
        image: img3,
        region: "United Kingdom",
        country: "England",
        place: "Countryside",
        price: 2000,
        weather: "night"
    },
    {
        image: img4,
        region: "Southeast Asia",
        country: "Burma",
        place: "Lake",
        price: 1800,
        weather: "morning"
    },
    {
        image: img5,
        region: "Italy",
        country: "Marino",
        place: "Camping",
        price: 800,
        weather: "night"
    },
    {
        image: img6,
        region: "Africa",
        country: "Iran",
        place: "Castles",
        price: 2300,
        weather: "night"
    },
    {
        image: img7,
        region: "Antarctica",
        country: "Antarctica",
        place: "Skiing",
        price: 1700,
        weather: "morning"
    },
    {
        image: img8,
        region: "Western Asia",
        country: "Armenia",
        place: "Windmills",
        price: 3000,
        weather: "night"
    },
    {
        image: img9,
        region: "Carribean",
        country: "Bahamas",
        place: "Pools",
        price: 200,
        weather: "night"
    },
    {
        image: img10,
        region: "North America",
        country: "Canada",
        place: "Arctic",
        price: 1500,
        weather: "morning"
    },
];
export { places };